export default __webpack_public_path__ + "static/media/MaternityMaternitypre-hospitalscreeningtool-V13.8292469a.jpg";